export const MappingWidgetType = {
  Mapping: 'mapping',
  Result: 'result',
  Splitting: 'splitting',
  Type: 'type',
}

export const DocFlowSplittingType = {
  Area: 'area',
  Keyword: 'keyword',
  Pages: 'pages',
}

export const DocFlowAccurancy = {
  High: 90,
  Highest: 95,
  Low: 70,
  Middle: 80,
}

export const DocFlowWidgetMappingType = {
  ContractId: 'contract_id',
  Email: 'email',
  ExternalId: 'external_id',
  Name: 'name',
  Phone: 'phone',
}
